
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rdv",
      function () {
        return require("private-next-pages/rdv.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rdv"])
      });
    }
  